import _ from 'lodash';

import {
	GET_SETTINGS_SUCCESS,
	GET_SETTINGS_START,
	GET_SETTINGS_FAIL,
	UPDATE_SETTINGS_SUCCESS,
	UPDATE_SETTINGS_START,
	UPDATE_SETTINGS_FAIL,
} from 'admin/constants';

export const initialState = {
	fetching: false,
};

export default function settingsReducer(state = initialState, action) {
	if (action.type === GET_SETTINGS_START || action.type === UPDATE_SETTINGS_START) {
		return {
			...state,
			fetching: true,
		};
	}

	if (action.type === GET_SETTINGS_FAIL || action.type === UPDATE_SETTINGS_FAIL) {
		return {
			...state,
			fetching: false,
		};
	}

	if (action.type === GET_SETTINGS_SUCCESS) {
		const payload = _.get(action, 'payload', {});
		const nextState = _.mapValues(payload, (v, k) => ({
			...state[k],
			...v,
		}));

		return {
			...state,
			...nextState,
			fetching: false,
		};
	}

	if (action.type === UPDATE_SETTINGS_SUCCESS) {
		const nextState = action.payload || {};
		return {
			...state,
			...nextState,
			fetching: false,
		};
	}

	return state;
}
